module.exports = __webpack_public_path__ + "static/img/endless_mode_title.a314710.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/endless_mode/endless_mode_title.png
// module id = LBEN
// module chunks = 1